module.exports = __webpack_public_path__ + "img/yellow-icon-en(1).3a76b4b0.png";